<template>
    <app-wrapper>
        <app-header is-hidden-menu :loan="loan" medium-max-width="max-w-1000">
          <template #top>
            <p class="text-lg font-semibold">
              We're sorry, but it looks like we're currently unable to process loans in your state. Unfortunately, we couldn’t find any partners to support your loan application at this time.
            </p>
          </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">
          <div class="mt-6 shadow-floating bg-white rounded-lg -mb-16 relative z-10">
            <!---->
            <div class="flex flex-col md:flex-row md:items-center justify-center">
              <div class="w-full">
                <div
                    class="flex flex-col md:flex-row md:flex-wrap items-center app-header-top p-7 md:py-10 md:px-14"
                >
                  <div class="w-full app-header-top">
                    <div class="w-full flex items-center">
                      <CreditStrongContent />
                    </div>
                  </div>

                  <div class="w-full text-center">
                    <button
                        id="btn-creditstrong"
                        @click.prevent="offerLoanToCreditStrong()"
                        class="w-full inline-block bg-green-500 text-white font-medium px-8 py-4 my-6 rounded-full hover:bg-darkgreen no-underline max-w-64 border-1 border-green-400 outline outline-offset-1 outline-green-400 hover:bg-green-600 hover:border-green-600 transition duration-300 ease-in-out"
                    >
                                            <span v-if="loading">
                                                <i class="fa fa-spinner fa-spin mr-2" />
                                                <span>Processing...</span>
                                            </span>
                      <span v-else>
                                                <span>GET STARTED NOW</span>
                                            </span>
                    </button>

                    <div v-if="error" class="text-red-500 text-sm mt-2">
                      There was an error. Please try again later.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </app-body>
    </app-wrapper>
</template>

<script>
import CreditStrongContent from "./CreditStrongContent.vue";
import { analytics } from "./../../../analytics";

export default {
    mixins: [
        require("../../../mixins/InteractsWithGtag").default,
        require("../../../mixins/PageViewAnalytics").default
    ],

    props: ["loan", "creditstrongobject"],
  
    components: {
      CreditStrongContent,
    },

    data() {
        return {
            gTagPageName: "LOAN_PENDING",
            loading: false,
            error: null,
            intervalId: null,
        };
    },

    methods: {
      offerLoanToCreditStrong() {
        this.loading = true;
        this.error = false;
  
        analytics.marketPlaceSignUpEvents.clickOfferLoanToCreditStrong({
          loan_id: this.loan.id,
          user_id: this.loan.user_id,
          loan_status: this.loan?.status ?? null,
          event_label: "loan-pending",
        });
  
        this.$http
            .post(`/account/loans/${this.loan.id}/offer-to-credit-strong`)
            .then((response) => {
              if (response.data.status === "success") {
                let url = response.data.url;
                window.location.href = url;
              }
            })
            .catch((error) => {
              this.error = true;
              console.error(error);
            })
            .finally(() => {
              this.loading = false;
            });
      },
    },
  
    mounted() {
        this.intervalId = setInterval(() => {
          this.$http.get(`/signup/check-marketplace-status/${this.loan.id}`)
            .then((response) => {
              // The status endpoint no longer rebroadcasts MarketplaceSold, so this page
              // can no longer rely on the global Echo reload to notice a late sale. It
              // has to act on the answer it already asked for: sold means a handoff is
              // waiting, and only a reload can render it.
              if (response.data && response.data.status === 'sold') {
                window.location.reload();
              }
            })
            .catch(() => {});
        }, 1 * 60 * 1000);
    },

    beforeDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },    
};
</script>
